import React from 'react';
import { IconButton } from '@material-ui/core';
import { useHistory } from 'react-router';
import DeleteIcon from '@material-ui/icons/Delete';
import { getState } from 'redux/store';
import { ReducerKeys } from 'redux/reducers';
import { useDispatch } from 'react-redux';
import VatReturnDetailsActions from 'redux/reducers/vatReturn_detail_reducer/actions';
// import * as VatReturnUtls from '../../../../utils';
// import { SupplyTypes } from 'config';

interface IProps {
  rowIndex: number;
  mode: 'VIEW' | 'EDIT';
}

interface IVatCorrection {
  vat_correction_id: number;
  vat_return_id: number;
  period_id: number;
  period: string;
  country_id: number;
  country: string;
  amount: number;
  year: number;
}

export default function ActionsBlock(props: IProps) {
  // const history = useHistory();
  const MODE = props.mode;
  const dispatch = useDispatch();

  const handleClick = (rowIndex: number) => {
    let newData: Array<IVatCorrection> = new Array<IVatCorrection>();
    let reduxData = getState(ReducerKeys.VATRETURN_DETAIL_REDUCER)
      .vatReturnDetail.vatCorrections;
    let item = null;
    for (let index in reduxData) {
      if (Number.parseInt(index) !== rowIndex) newData.push(reduxData[index]);
      else item = reduxData[index];
    }
    dispatch(VatReturnDetailsActions.setVatCorrections(newData));
    msconChanges(item);
  };

  const msconChanges = (object: IVatCorrection) => {
    let reduxData = getState(ReducerKeys.VATRETURN_DETAIL_REDUCER)
      .vatReturnDetail.mscon;
    let newMsconData = [];
    for (let item of reduxData) {
      if (item.country_id !== object.country_id) newMsconData.push(item);
      else {
        let obj = {
          ...item,
          total_correction: item.total_correction - object.amount,
          total_amount_due: item.total_amount_due - object.amount,
        };
        if (obj.total_correction > 0 || obj.total_amount_due > 0) {
          newMsconData.push(obj);
        }
      }
    }
    dispatch(VatReturnDetailsActions.setMsconAction(newMsconData));
  };

  return (
    <div>
      <IconButton
        disabled={MODE === 'VIEW'}
        color="primary"
        onClick={() => handleClick(props.rowIndex)}
      >
        <DeleteIcon />
      </IconButton>
    </div>
  );
}
